import React, {useContext, useEffect} from 'react';
import {Col, Container, Form, Row} from "react-bootstrap";
import * as URL from "service/UrlConstant";
import {
    dateToString, formatDateString, getPrevBusDate,
    yearMonthDayToPickerDateFormat
} from "utils/FormatUtils";
import {ReportsPanelContext} from "./context";
import {SecurityContext} from "context/security";
import * as b64 from "base64-js";
import {gunzipSync} from "fflate";
import {ToastContext} from "context/Toast";
import {
    REPORTS_PANEL_VIEW_REPORT_PAGE
} from "./context/ReportsPanelContext";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {EntityAccountsContext} from "components/entity-accounts/context";
import ReportFilterFolders from "./ReportFilterFolders";
import {FilterContext} from "layouts/SidePanelLayout";
import {getAllErrorValuesAsString} from "../../utils/ErrorUtils";
import {isValidDate} from "../../utils/RegexUtils";
import {useLocation} from "react-router";

export default function ReportFilter() {

    const {
        reportsFilterSearchState,
        setReportsFilterSearchState,
        reportsFolderFileState,
        reportsPanelPageState,
        reportsDisplayState,
        setReportsDisplayState,
        reportsExcelDisplayState,
        setReportsExcelDisplayState,
        displayReportPanelPage,
        clearReportSearchAndLoadReportsHome,
        validateReportFolderSearch,
        forceReloadOfFoldersAndFiles,
        checkForReloadOfFolders,
        isHomeRequest,
        setIsHomeRequest,
        setShowGridToolbar,
        savedReportDate
    } = useContext(ReportsPanelContext);
    const {
        entityAccounts,
        clearEntityAccounts,
        validateEntityAccountSearch,
        setManagerAndAccountDetails,
        setShowAccounts,
        entityAccountsOptions,
        populateDefaultEntity, getHolidayExceptionForGivenMgrAcct
    } = useContext(EntityAccountsContext);
    const {makeGetRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const {showFilter, setShowFilter} = useContext(FilterContext);
    const location = useLocation();


    const handleSearchClear = () => {
        clearEntityAccounts();
        clearReportSearchAndLoadReportsHome();
    }

    useEffect(() => {
        populateDefaultEntity(true,false)
    }, [entityAccountsOptions])

    useEffect(() => {
        if(isHomeRequest)
            setIsHomeRequest(false)
    }, [])

    const handleChange = (e) => {

        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const reportsFilterSearchStateToUpdate = JSON.parse(JSON.stringify(reportsFilterSearchState));
        reportsFilterSearchStateToUpdate['formErrors']['reportsSearch'][e.currentTarget.name] = '';

        if (targetName === 'effectiveDate') {
            if (reportsFilterSearchStateToUpdate.reportsSearch.effectiveDate !== targetValue) {
                reportsFilterSearchStateToUpdate.reportsSearch.effectiveDate = targetValue;
                setReportsFilterSearchState(reportsFilterSearchStateToUpdate);

                checkForReloadOfFolders(reportsFilterSearchStateToUpdate.reportsSearch.accountId, reportsFilterSearchStateToUpdate.reportsSearch.effectiveDate,reportsFilterSearchStateToUpdate.reportsSearch.managerId);
            }
        }
    }

    const validateSearch = () => {

        const entityAccountErrors = validateEntityAccountSearch(true,false);

        let effectDateErrors = {}
        const effDt = reportsFilterSearchState.reportsSearch.effectiveDate;
        if (!effDt || !isValidDate(effDt)) {
            effectDateErrors['effectiveDate'] = 'Please select close of business date';

            const reportsFilterSearchErrors = JSON.parse(JSON.stringify(reportsFilterSearchState));
            reportsFilterSearchErrors.formErrors.reportsSearch = effectDateErrors;
            setReportsFilterSearchState(reportsFilterSearchErrors);
        }

        const folderFileErrors = validateReportFolderSearch();

        return (Object.keys(entityAccountErrors).length > 0 || Object.keys(effectDateErrors).length > 0 || Object.keys(folderFileErrors).length > 0);
    }

    const viewReportFile = (e) => {
        e.preventDefault();

        // Validate search inputs
        if (validateSearch()) {
            return;
        }

        const searchParams = {
            accountId: reportsFilterSearchState.reportsSearch.accountId,
            effectiveDate: dateToString(reportsFilterSearchState.reportsSearch.effectiveDate.toString()),
            folder: reportsFolderFileState.reportsSearch.folder,
            fileName: reportsFolderFileState.reportsSearch.fileName,
            holidayException: getHolidayExceptionForGivenMgrAcct(reportsFilterSearchState.reportsSearch.managerId, reportsFilterSearchState.reportsSearch.accountId)
        }

        setShowFilter(!showFilter)

        const onSuccess = (response) => {
            const fileName = reportsFolderFileState.reportsSearch.fileName;
            const fileType = fileName?.split('.').pop().toLowerCase();

            // Validate file type
            if (!['pdf', 'csv', 'xlsx'].includes(fileType)) {
                error(`Unsupported file type: ${fileType}`);
                return;
            }

            // Handle file response
            try {
                handleFileResponse(response, fileType);

            } catch (err) {
                console.error('Error processing file response:', err);
                error('An error occurred while processing the file.');
            }
        }

        const onError = (err) => {
            const errorMsg = err?.response?.data
                ? getAllErrorValuesAsString(err.response.data)
                : 'Unknown error occurred';
            console.error('Error when retrieving file list - ', errorMsg);
            error('There was an error with loading the selected report.');
        };

        // Make API request
        makeGetRequest(URL.REPORT_FOLDERS_FILES_FILE_URL, searchParams, onSuccess, onError);
    }

    const handleFileResponse = (response, fileType) => {
        if (!response.data) {
            console.error("No data available to display.");
            const reportsPdfDisplay = JSON.parse(JSON.stringify(reportsDisplayState));
            reportsPdfDisplay.reportData = [];
            setReportsDisplayState(reportsPdfDisplay);
            return;
        }
        const based64Decoded = b64.toByteArray(response.data);
        const decompressed = gunzipSync(based64Decoded);
        displayFile(decompressed, fileType);
        setShowGridToolbar(response.data && response.data.length > 0)
        displayReportPanelPage(REPORTS_PANEL_VIEW_REPORT_PAGE);
    };

    const displayFile = (data, fileType) => {
        updateDisplayState(data, fileType, setReportsDisplayState, reportsDisplayState);
    };

    const updateDisplayState = (data, fileType, setStateFunction, displayState) => {
        const updatedDisplayState = JSON.parse(JSON.stringify(displayState));
        updatedDisplayState.reportData = {data: data};
        updatedDisplayState.isReportSavedSearch = false;
        updatedDisplayState.reportSavedSearchName = '';
        updatedDisplayState.reportSavedSearchId = '';
        updatedDisplayState.reportSearchData = {
            managerId: reportsFilterSearchState.reportsSearch.managerId,
            managerName: reportsFilterSearchState.reportsSearch.managerName,
            subManagerId: reportsFilterSearchState.reportsSearch.subManagerId,
            accountId: reportsFilterSearchState.reportsSearch.accountId,
            accountName: reportsFilterSearchState.reportsSearch.accountName,
            clientCode: reportsFilterSearchState.reportsSearch.clientCode,
            effectiveDate: reportsFilterSearchState.reportsSearch.effectiveDate,
            fileName: reportsFolderFileState.reportsSearch.fileName,
            folder: reportsFolderFileState.reportsSearch.folder,
            fileType: fileType,
            holidayException: reportsFilterSearchState.reportsSearch.holidayException
        };
        setStateFunction(updatedDisplayState);
    };

    useEffect(() => {

        setShowAccounts(true, false)
        //Load the entity accounts component data into filter search - on initial load
        const reportsFilterSearchStateToSet = JSON.parse(JSON.stringify(reportsFilterSearchState));
        reportsFilterSearchStateToSet.reportsSearch.managerId = entityAccounts.managerId;
        reportsFilterSearchStateToSet.reportsSearch.managerName = entityAccounts.managerName;
        reportsFilterSearchStateToSet.reportsSearch.accountId = entityAccounts.accountId;
        reportsFilterSearchStateToSet.reportsSearch.clientCode = entityAccounts.accountCode;
        reportsFilterSearchStateToSet.reportsSearch.accountName = entityAccounts.accountName;

        //check if the context date is not empty we should use it.
        if (savedReportDate)
            reportsFilterSearchStateToSet.reportsSearch.effectiveDate = yearMonthDayToPickerDateFormat(savedReportDate)
        setReportsFilterSearchState(reportsFilterSearchStateToSet);

    }, []);

    useEffect(() => {

        if (REPORTS_PANEL_VIEW_REPORT_PAGE === reportsPanelPageState.currentPage && reportsDisplayState.isReportSavedSearch === true) {
            //Load the pdf saved search details for saved report search
            let reportsFilterSearchStateSavedReport = JSON.parse(JSON.stringify(reportsFilterSearchState));
            reportsFilterSearchStateSavedReport.reportsSearch.managerId = reportsDisplayState.reportSearchData.managerId;
            reportsFilterSearchStateSavedReport.reportsSearch.managerName = reportsDisplayState.reportSearchData.managerName;
            reportsFilterSearchStateSavedReport.reportsSearch.accountId = reportsDisplayState.reportSearchData.accountId;
            reportsFilterSearchStateSavedReport.reportsSearch.clientCode = reportsDisplayState.reportSearchData.clientCode;
            reportsFilterSearchStateSavedReport.reportsSearch.accountName = reportsDisplayState.reportSearchData.accountName;
            reportsFilterSearchStateSavedReport.reportsSearch.effectiveDate = yearMonthDayToPickerDateFormat(reportsDisplayState.reportSearchData.effectiveDate);
            reportsFilterSearchStateSavedReport.formErrors.reportsSearch = {};
            setManagerAndAccountDetails(reportsDisplayState.reportSearchData.managerId, reportsDisplayState.reportSearchData.managerName,
                reportsDisplayState.reportSearchData.accountId, reportsDisplayState.reportSearchData.accountName,
                reportsDisplayState.reportSearchData.clientCode, true,false, getHolidayExceptionForGivenMgrAcct(reportsDisplayState.reportSearchData.managerId, reportsDisplayState.reportSearchData.accountId));

            setReportsFilterSearchState(reportsFilterSearchStateSavedReport);
            //Force reload and selection for folder and fileName
            forceReloadOfFoldersAndFiles(reportsDisplayState.reportSearchData.folder, reportsDisplayState.reportSearchData.fileName,
                reportsFilterSearchStateSavedReport.reportsSearch.accountId, reportsFilterSearchStateSavedReport.reportsSearch.effectiveDate,reportsFilterSearchStateSavedReport.reportsSearch.managerId);
        }

    }, [reportsPanelPageState]);

    useEffect(() => {
        const entityAccountsChange = {...entityAccounts};

        if(reportsFilterSearchState.reportsSearch.managerId !== entityAccounts.managerId
            || reportsFilterSearchState.reportsSearch.accountId !== entityAccounts.accountId) {

            const updatedEntityAccountsState = JSON.parse(JSON.stringify(reportsFilterSearchState));
            updatedEntityAccountsState.reportsSearch.managerId = entityAccounts.managerId;
            updatedEntityAccountsState.reportsSearch.managerName = entityAccounts.managerName;
            updatedEntityAccountsState.reportsSearch.accountId = entityAccounts.accountId;
            updatedEntityAccountsState.reportsSearch.clientCode = entityAccounts.accountCode;
            updatedEntityAccountsState.reportsSearch.accountName = entityAccounts.accountName;
            updatedEntityAccountsState.reportsSearch.holidayException = entityAccounts.holidayException;
            //check if the context date is not empty we should use it.
            if (savedReportDate)
                updatedEntityAccountsState.reportsSearch.effectiveDate = yearMonthDayToPickerDateFormat(savedReportDate)
            setReportsFilterSearchState(updatedEntityAccountsState);
            checkForReloadOfFolders(updatedEntityAccountsState.reportsSearch.accountId, updatedEntityAccountsState.reportsSearch.effectiveDate, updatedEntityAccountsState.reportsSearch.managerId);
        }

    }, [entityAccounts]);

    //Defaults "Close of Business Date" to previous business date
    useEffect(()=>{
        if(!isHomeRequest && reportsDisplayState.isReportSavedSearch !== true && reportsPanelPageState.currentPage !== REPORTS_PANEL_VIEW_REPORT_PAGE) {
            setReportsFilterSearchState((prevReportsFilterSearchState)=>({
                ...prevReportsFilterSearchState,
                reportsSearch:{
                    ...prevReportsFilterSearchState.reportsSearch,
                    effectiveDate: formatDateString(String(getPrevBusDate()), 'YYYY-MM-DD')
                }
            }));
        }
        setIsHomeRequest(false);

    }, [location.key])

    //trigger that load folder
    useEffect(() => {
        const {managerId, accountId} = entityAccounts;
        const {effectiveDate} = reportsFilterSearchState.reportsSearch;
        if (managerId && accountId && effectiveDate && isValidDate(effectiveDate)) {
            checkForReloadOfFolders(accountId, effectiveDate, managerId);
        }
    }, [entityAccounts.managerId, entityAccounts.accountId, reportsFilterSearchState.reportsSearch.effectiveDate])
    useEffect(() => {
         populateDefaultEntity(true,false)
     }, [entityAccountsOptions])
    return (<>

        <Container fluid className="mt-md-3 mt-sm-0">
            <Form onSubmit={(e) => e.preventDefault()}>
                <h2 className="d-none d-md-block">Search</h2>
                <Row>

                    <EntityAccountsComponent hideSwapLob={false}/>

                    <Col sm={12} md={12}>
                        <Form.Group controlId="formGridAddress1">
                            <Form.Label className="filter-input-label">Close of Business Date *</Form.Label>
                            <Form.Control type="date"
                                          value={reportsFilterSearchState.reportsSearch.effectiveDate}
                                          onChange={handleChange} name={'effectiveDate'}
                                          isInvalid={!!reportsFilterSearchState.formErrors.reportsSearch.effectiveDate}/>
                            <Form.Control.Feedback type={'invalid'}>
                                <b><i className="bi bi-exclamation-circle"></i>{reportsFilterSearchState.formErrors.reportsSearch.effectiveDate}</b>
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <ReportFilterFolders/>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" type='submit'
                                onClick={viewReportFile}>View Report
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3"
                                href="#" onClick={handleSearchClear}>Clear
                        </button>
                    </Col>
                </Row>
            </Form>

        </Container>

    </>);

}